import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'pregnancy_maternity_status_1'

export const dataPointDefinition = {
  retracedId: 'pregnancy_maternity_status_1',
  name: 'Pregnancy / Maternity Status',
  description:
    'Pregnancy refers to the state of being pregnant. Maternity can refer to the state of being a mother, and also may be used as an adjective that encompasses pregnancy, childbirth, and post-childbirth (including, e.g., during maternity leave and breastfeeding).',
  meta: {
    slcpMeta: {
      key: 'disc-6--10',
      number: 'WT-DIS-6-10',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'wt-dis-4',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[1],wt-dis-3,Yes',
      machineShowHide: '[1],wt-dis-3,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'disc-6--10', version: '1.7.0', provider: 'slcp'}],
  sortingId: 26600,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
